import { render, staticRenderFns } from "./UserNotifications.vue?vue&type=template&id=65675fc4&scoped=true"
import script from "./UserNotifications.vue?vue&type=script&lang=js"
export * from "./UserNotifications.vue?vue&type=script&lang=js"
import style0 from "./UserNotifications.vue?vue&type=style&index=0&id=65675fc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65675fc4",
  null
  
)

export default component.exports